// This import loads the firebase namespace along with all its type information.
import ReleaseZone from './release-zone-model'

export async function load_releaseZones(): Promise<ReleaseZone[]> {
  throw 'Not implemented'
}

export async function delete_releaseZone(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_releaseZone(): Promise<ReleaseZone> {
  throw 'Not implemented'
}
